


export class construirMovimientoInventarioVenta {

  constructor({
    idProducto,
    cantidad,
    idReferencia,
    periodoId,
    createdBy = 3
  }) {

    if (!idProducto) throw new Error("ID de producto requerido");
    if (!cantidad || cantidad <= 0) throw new Error("Cantidad debe ser mayor a 0");
    if (!idReferencia) throw new Error("Venta requerida");
    if (!periodoId) throw new Error("Periodo requerido");

    this.id_producto = idProducto;
    this.tipo_movimiento = "salida";
    this.cantidad = Number(cantidad);
    this.id_referencia = idReferencia;
    this.origen = "Venta";
    this.observacion = `Salida por venta ${idReferencia}`;
    this.created_by = createdBy;
    this.fecha_creacion = new Date().toISOString();
    this.periodo_id = periodoId;
  }

  actualizarCantidad(nuevaCantidad) {
    if (nuevaCantidad <= 0) throw new Error("Cantidad debe ser > 0");
    this.cantidad = nuevaCantidad;
  }

  generarObservacion() {
    this.observacion = `Salida por venta ${this.id_referencia}`;
  }
}